
module.exports = (...args) => {
}
